<template>
    <div class="pcborder">
        <v-layout row class="hidden-xs-only">
            <v-flex xs6>
                <div v-if="p1" class="pcard p1">
                    <v-avatar :size="as">
                        <v-img :src="p1.profilepic" />
                    </v-avatar>
                    <span class="pl-1 subheading font-weight-light">
                    {{p1.firstname}} {{p1.lastname}}
                    </span>
                </div>
            </v-flex>
            <v-flex xs6>
                <div v-if="p2" class="pcard p2">
                    <span class="right">
                        <span class="subheading font-weight-light pr-1">
                           {{p2.firstname}} {{p2.lastname}}
                        </span>
                        <v-avatar :size="as" >
                            <v-img :src="p2.profilepic" />
                        </v-avatar>
                    </span>
                </div>
            </v-flex>
        </v-layout>

        <v-layout row class="hidden-sm-and-up">
            <v-flex>
                <div v-if="p1" class="pcard p1">
                    <div class="text-xs-center">
                        <v-avatar :size="as">
                            <v-img :src="p1.profilepic" />
                        </v-avatar>
                    </div>
                    <div class="text-xs-center">
                       <span class="pl-1 subheading font-weight-light">
                    {{p1.firstname}} {{p1.lastname}}
                    </span>
                    </div>
                </div>
            </v-flex>
            <v-flex>
                <div v-if="p2" class="pcard p2">
                    <div class="text-xs-center">
                        <v-avatar :size="as">
                            <v-img :src="p2.profilepic" />
                        </v-avatar>
                    </div>
                    <div class="text-xs-center">
                        <span class="subheading font-weight-light pr-1">
                           {{p2.firstname}} {{p2.lastname}}
                        </span>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    export default {
        props:['p1','p2'],
        components: {},
        name: "DoublesCard",
        data() {
            return {
                as:50
            }
        },
        mounted() {
        },
        methods: {}
    }
</script>

<style scoped>
    .pcborder{
        padding:4px;
        width:100%;
        max-width:400px;
        background-color: #222;
        border-top-left-radius: 25px;
        border-bottom-right-radius: 25px;
        border-top-right-radius: 25px;
    }
    .pcard{
        padding-top: 5px;
        padding-bottom: 5px;
        text-overflow: ellipsis;
        display:inline-block;
        color:white;
        font-weight: 500;
        width:100%;
        border:solid thin #ccc;
    }
    .p1{
        padding-left:3px;
        background-color:#D50000;
        border-top-left-radius: 25px;
        border-bottom-right-radius: 25px;
    }
    .p2{
        padding-right:3px;
        background-color:#2196F3;
        border-bottom-right-radius: 25px;
        border-top-right-radius: 25px;
        border-top-left-radius: 25px;
    }
</style>